import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=3d6d5a8a"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d6d5a8a')) {
      api.createRecord('3d6d5a8a', component.options)
    } else {
      api.reload('3d6d5a8a', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=3d6d5a8a", function () {
      api.rerender('3d6d5a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemPage/Editor.vue"
export default component.exports